export const TEN_ITEMS_HEIGHT = 400
